import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGrid, faChevronDown } from '@fortawesome/pro-solid-svg-icons';
import { TiptapButton } from '../TiptapButton';
import { useEditorContext } from '../../editor_context';
import { ButtonGroup, Menu, MenuButton, MenuList, MenuItem } from '@chakra-ui/react';
import { _js } from '@ifixit/localize';

const gridModes = {
   columns: _js('Columns'),
   rows: _js('Rows'),
};

const GridToggleButton = () => {
   const { editor } = useEditorContext();

   return (
      <TiptapButton
         onClick={() => editor.chain().focus().toggleGrid(null).run()}
         isActive={editor.isActive('grid')}
         isDisabled={!editor.can().toggleGrid(null)}
         icon={<FontAwesomeIcon icon={faGrid} />}
         title={_js('Insert grid layout')}
      />
   );
};

export function GridDropdown() {
   return (
      <ButtonGroup size="sm" isAttached variant="outline">
         <GridToggleButton />
         <GridDropdownMenu />
      </ButtonGroup>
   );
}

function GridDropdownMenu() {
   const { editor } = useEditorContext();

   return (
      <Menu>
         <MenuButton as={TiptapButton} icon={<FontAwesomeIcon icon={faChevronDown} />} />
         <MenuList>
            {Object.entries(gridModes).map(([mode, label]) => {
               const columns = mode === 'columns' ? 2 : null;
               const gridUpdateHandler = () => editor.chain().focus().setGridMode(columns).run();
               const gridStartHandler = () => editor.chain().focus().toggleGrid(columns).run();
               const onClickHandler = editor.isActive('grid')
                  ? gridUpdateHandler
                  : gridStartHandler;
               return (
                  <MenuItem key={mode} onClick={onClickHandler}>
                     {label}
                  </MenuItem>
               );
            })}
         </MenuList>
      </Menu>
   );
}
